import { FC } from 'react'
import RevokeButton from 'components/Button/RevokeButton'
import { useSubmitViolationItemDecision } from 'hooks'

export const RejectRisk: FC<any> = (props) => {
    const { item, d } = props

    const { mutateAsync: submitRiskDecision, isLoading: isSubmitting } =
        useSubmitViolationItemDecision(
            'Requests',
            item.businessRequestId,
            item.id,
        )

    return (
        <RevokeButton
            size={'small'}
            onClick={() => {
                const revokeReq = {
                    stepId: item.currentApprovalStepId,
                    decisionId: d.decisionId,
                }
                submitRiskDecision(revokeReq)
            }}
            loading={isSubmitting}
        >
            {d.decisionFriendlyName}
        </RevokeButton>
    )
}
